import { Container, Title } from '@mantine/core'
import { createFileRoute } from '@tanstack/react-router'
import PlaceSelect from 'components/place/PlaceSelect'
import ProductsOnPlaceTables from 'components/place/ProductsOnPlaceTables'
import { placesQueryOptions } from 'hooks/places'

export const Route = createFileRoute('/_auth/place/{-$placeId}')({
  component: RouteComponent,
  beforeLoad: async ({ context: { queryClient } }) => {
    return await queryClient.ensureQueryData(placesQueryOptions)
  },
})

function RouteComponent() {
  const navigate = Route.useNavigate()
  const placeId: string | null = Route.useParams().placeId

  function onPlaceSelect(placeId?: string) {
    if (placeId) navigate({ to: `/place/${placeId}` })
    else navigate({ to: `/place` })
  }

  return (
    <div>
      <Title order={1} mb="md">
        Sprawdź produkty na półce
      </Title>
      <Container mt="xl" m={0} fluid>
        <PlaceSelect onPlaceSelect={onPlaceSelect} />
      </Container>
      <ProductsOnPlaceTables placeId={placeId} />
    </div>
  )
}
